var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.translationHeader))]),_c('a-RenderHTML',{staticClass:"mt-4",attrs:{"value":_vm.translationTerminationInstructions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }